var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFiji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0107C32 24.8472 24.8365 32.0107 16 32.0107C7.1635 32.0107 0 24.8472 0 16.0107C0 16.0146 16 0.0124922 16 0.0107422C24.8365 0.0107422 32 7.17424 32 16.0107Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 7.66284V13.0593L10.4344 7.66284H15.9996Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34782 16.0106H13.0486L8.34782 9.74976L7.65219 14.6193L8.34782 16.0106Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0108H16C16 15.9965 16 15.9825 16 15.968C15.9857 15.9823 15.9715 15.9966 15.9572 16.0108Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.35855C16 5.54324 16 3.69855 16 0.0107422H15.9973C7.162 0.0122422 0 7.17505 0 16.0107H8.34781V11.3101L13.0486 16.0107H15.9573C15.9716 15.9965 15.9858 15.9822 16.0001 15.9679C16.0001 14.89 16.0001 13.9282 16.0001 13.0594L11.2992 8.35855H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.09766C5.59226 3.52259 3.51188 5.60297 2.08694 8.10541V16.0107H6.26088V6.27172V6.27159H16C16 4.95516 16 3.70103 16 2.09766H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0432L10.3154 8.35864H8.34787V8.35877L15.9999 16.0108H16C16 16.0108 16 14.6541 16 14.0432Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 10.4455V16.0106C18.0869 19.7381 22.9565 20.8803 22.9565 20.8803C22.9565 20.8803 27.8261 19.7381 27.8261 16.0106V10.4455L22.9565 9.0542L18.0869 10.4455Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8261 10.4456V8.35864H18.0869V10.4456H22.2608V14.6196H18.0869V16.0108V16.0109L22.2608 16.011V20.667C22.6806 20.8155 22.9565 20.8804 22.9565 20.8804C22.9565 20.8804 23.2323 20.8156 23.6521 20.667V16.0109H27.8261V16.0108V14.6195H23.6521V10.4455H27.8261V10.4456Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFiji);
export default __webpack_public_path__ + "static/media/flag_fiji.1a107f59ea3b0a5a26f623dfbd4c4dd0.svg";
export { ForwardRef as ReactComponent };